export default __webpack_public_path__ + "static/media/2123258.221f563a.jpg";